// extracted by mini-css-extract-plugin
export default {"container":"es-z","brandName":"fs-z","productName":"gs-z","aboveGalleryInfo":"hs-z","belowGalleryInfo":"is-z","breakLongProductName":"js-z"};